<template>
  <div @click="$emit('closeGallery')"  v-if="openGallery" :class="{ 'shadow' : rowPosition, 'shadow-custom': !rowPosition, 'd-none': !openGallery }">
    <div @click="stayCalm" class="inner-box">
      <div class="row">
        <div class="left-arrow">
          <i @click="showPrev" class="fas fa-angle-left"></i>
        </div>
        <div class="content">
          <img v-if="sources.length" :src="src"  alt="">
        </div>
        <div @click="showNext" class="right-arrow">
          <i class="fas fa-angle-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      src: '',
      srcIndex: 0,
      files: [],
    }
  },
  name: 'GalleryFiles',
  props: {
    rowPosition: {
      type: Boolean,
      required: true
    },
    sources: {
      required: true,
      type: Object
    },
    openGallery: {
      required: true,
      type: Boolean
    }
  },
  methods: {
    stayCalm(e){
      e.stopPropagation();
    },
    showPrev(){
      if(this.sources.length){
        this.srcIndex--
        this.src = this.sources[this.srcIndex] ? this.sources[this.srcIndex] : this.sources[++this.srcIndex];
      }
    },
    showNext(){
      if(this.sources.length){
        this.srcIndex++
        this.src = this.sources[this.srcIndex] ? this.sources[this.srcIndex] : this.sources[--this.srcIndex];
      }
    },
    getFilesSrc(sources){
      sources.map((src, idx) => {
        let splited = src.split('&amp;');
        if(splited.length > 1){
          this.files.push(splited[0]);
          this.sources.splice(idx, 1);
        }
      })
    }
  },
  mounted() {
    this.src = this.sources[this.srcIndex];
    this.getFilesSrc(this.sources);
  },
  watch: {
    openGallery: function(){

    }
  }
}
</script>

<style scoped>
.shadow{
  position: absolute;
  z-index: 668;
  background: #000000a3;
  top: -30rem;
  left: 0rem;
  height: 110vh;
  width: 100%;
  padding-top: 10rem;
  cursor: default;
}

.shadow-custom{
  position: absolute;
  z-index: 668;
  background: #000000a3;
  top: -46rem;
  left: 0rem;
  height: 110vh;
  width: 140.15%;
  padding-top: 10rem;
  cursor: default;
}
.d-none{
  display: none;
}

.inner-box{
  background: white;
  margin: 0 auto;
  width: 80%;
  height: 85vh;
  border-radius: 10px;
  padding: 4rem;
}
.row{
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 4rem;
}
.content{
  border-radius: 10px;
  width: 90%;
  background: #f5f5f5;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  box-shadow: 0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19) !important;
}
.content img{
  width: 100%;
}
.fas{
  cursor: pointer;
  transition: .2s;
}
.fas:hover{
  color: #545454;
}
</style>